import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { ReconService } from "../service/ReconService";
import { NodeService } from "../service/NodeService";
import { WarnService } from "../service/WarnService";
import { CruiseService } from "../service/CruiseService";


let nodeContext: ServiceContext | null = null;
function createNodeContext(): ServiceContext {
    if (nodeContext == null) {
        const service = new NodeService();
        nodeContext = ServiceFactory.build(
            "biz_re_node",
            "/rec/node",
            "/rec/node",
            service
        );
        nodeContext.typesName = 'rec-node-type';
    }
    return nodeContext;
}

let reconContext: ServiceContext | null = null;
function createReconContext(): ServiceContext {
    if (reconContext == null) {
        const service = new ReconService();
        reconContext = ServiceFactory.build(
            "biz_re_recon",
            "/rec/recon",
            "/rec/recon",
            service
        );
        reconContext.statesName = 'rec-recon-state';
    }
    return reconContext;
}

let warnContext: ServiceContext | null = null;
function createWarnContext(): ServiceContext {
    if (warnContext == null) {
        const service = new WarnService();
        warnContext = ServiceFactory.build(
            "biz_re_warn",
            "/rec/warn",
            "/rec/warn",
            service
        );
    }
    warnContext.statesName = 'rec-warn-state';
    return warnContext;
}

let cruiseContext: ServiceContext | null = null;
function createCruiseContext(): ServiceContext {
    if (cruiseContext == null) {
        const service = new CruiseService();
        cruiseContext = ServiceFactory.build(
            "biz_re_cruise",
            "/rec/cruise",
            "/rec/cruise",
            service
        );
        cruiseContext.statesName = 'rec-cruise-state';
        cruiseContext.typesName = 'rec-cruise-type';
    }
    return cruiseContext;
}

export { nodeContext, cruiseContext, reconContext, warnContext, createNodeContext, createCruiseContext, createReconContext, createWarnContext };
